import SiteTemplate from '../models/site-template';

export const SITE_TEMPLATES: Array<SiteTemplate> = [SiteTemplate.getInstanceFromObject({
    id: 'b026a50b-c85d-4e53-8d29-fded0b48d9b4',
    name: 'Default',
})];
